/**
 * Custom statuses maintained on the UI - actual enums on the backend and for underlying
 * Digital Signature provider could be different.
 */
export const SIGN_STATUS = {
    CHECKING: 'CHECKING',
    SIGNED: 'SIGNED',
    UNSIGNED: 'UNSIGNED',
};
